
import { language, localLanguage } from '@/common/storage';

export default {
  name: 'LanguageSelector.vue',

  data: function data() {
    return {
      languages: [{
        value: 'zh-cn',
        label: '中文'
      }, {
        value: 'en',
        label: 'EN'
      }, {
        value: 'ja',
        label: '日本語'
      }]
    };
  },


  computed: {
    language: function language() {
      var lang = localLanguage.get() || 'zh-cn';
      return this.languages.find(function (item) {
        return item.value === lang;
      }).label;
    }
  },

  methods: {
    selectLanguage: function selectLanguage(val) {
      language.set(val);
      window.location.reload();
    }
  }
};